export default __webpack_public_path__ + "static/media/video_play.10711a42.svg";